"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const silo_1 = require("services/master-data/silo");
const silo_types_1 = require("./silo.types");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, silo_1._getSiloData)(dataStates);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: silo_types_1.siloTypes.SET_ERROR, payload: payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { target_queue_time_display: item.target_queue_time ? item.target_queue_time + ' Minutes' : '', target_lead_time_display: item.target_lead_time ? item.target_lead_time + ' Minutes' : '', created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: silo_types_1.siloTypes.SET_DATA_GRID, payload: payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: silo_types_1.siloTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: silo_types_1.siloTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode, dataItem } = payload;
    const data = {
        silo: dataItem.silo,
        is_active: dataItem.is_active,
        description: dataItem.description,
        target_lead_time: dataItem.target_lead_time,
        target_queue_time: dataItem.target_queue_time,
    };
    if (mutationMode === 'edit')
        data.id = dataItem.id;
    const response = mutationMode === 'add'
        ? yield (0, silo_1._postSiloData)(data)
        : yield (0, silo_1._putSiloData)(data);
    if (response.isError) {
        dispatch({
            type: silo_types_1.siloTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            }
        });
    }
    else {
        dispatch({
            type: silo_types_1.siloTypes.ON_SAVE_DATAITEM,
            payload: {
                mutationMode,
                dataItem,
                isSuccess: true,
            }
        });
    }
});
const onDeleteDataItem = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode, dataItem } = payload;
    const response = yield (0, silo_1._deleteSiloData)({ id: dataItem.id });
    if (response.isError) {
        dispatch({
            type: silo_types_1.siloTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            }
        });
    }
    else {
        dispatch({
            type: silo_types_1.siloTypes.ON_DELETE_DATAITEM,
            payload: {
                dataItem,
                mutationMode,
                isError: response.isError,
                isSuccess: !response.isError
            }
        });
    }
});
const onFilterChange = payload => dispatch => {
    dispatch({ type: silo_types_1.siloTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: silo_types_1.siloTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: silo_types_1.siloTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onLoading = () => dispatch => {
    dispatch({ type: silo_types_1.siloTypes.SET_LOADING, payload: true });
};
exports.default = {
    getDataGrid,
    onSaveDataItem,
    onClickMutation,
    onDeleteDataItem,
    onDataStateChange,
    onFilterChange,
    onSortChange,
    onCloseError,
    onLoading
};
